
    import './styles.scoped.css';
    export default {
  "segment__path": "awsui_segment__path_1edmh_7x9l6_161",
  "segment": "awsui_segment_1edmh_7x9l6_161",
  "segment__hover": "awsui_segment__hover_1edmh_7x9l6_188",
  "label": "awsui_label_1edmh_7x9l6_202",
  "root": "awsui_root_1edmh_7x9l6_216",
  "content": "awsui_content_1edmh_7x9l6_220",
  "content--small": "awsui_content--small_1edmh_7x9l6_220",
  "content--fit-height": "awsui_content--fit-height_1edmh_7x9l6_223",
  "content--without-labels": "awsui_content--without-labels_1edmh_7x9l6_226",
  "content--medium": "awsui_content--medium_1edmh_7x9l6_232",
  "content--large": "awsui_content--large_1edmh_7x9l6_244",
  "status-container": "awsui_status-container_1edmh_7x9l6_261",
  "chart-container": "awsui_chart-container_1edmh_7x9l6_265",
  "chart-container--fit-height": "awsui_chart-container--fit-height_1edmh_7x9l6_269",
  "chart-container-chart-plot": "awsui_chart-container-chart-plot_1edmh_7x9l6_274",
  "chart-container-chart-plot--fit-height": "awsui_chart-container-chart-plot--fit-height_1edmh_7x9l6_277",
  "inner-content": "awsui_inner-content_1edmh_7x9l6_283",
  "segment__highlight": "awsui_segment__highlight_1edmh_7x9l6_294",
  "segment--dimmed": "awsui_segment--dimmed_1edmh_7x9l6_309",
  "segment--highlighted": "awsui_segment--highlighted_1edmh_7x9l6_312",
  "label--dimmed": "awsui_label--dimmed_1edmh_7x9l6_329",
  "label--align-right": "awsui_label--align-right_1edmh_7x9l6_332",
  "label-text": "awsui_label-text_1edmh_7x9l6_340",
  "label__description": "awsui_label__description_1edmh_7x9l6_348",
  "label-line": "awsui_label-line_1edmh_7x9l6_355",
  "label--highlighted": "awsui_label--highlighted_1edmh_7x9l6_359",
  "popover-header": "awsui_popover-header_1edmh_7x9l6_363"
};
  